import React from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

// Types
import { Equipment } from '../../../types/Equipment';
import { ResourceType } from '../../../types/ResourceType';

// Common
import { CustomImageList } from '../../common/CustomImageList';

interface EquipmentImageProp {
  equipment: Equipment;
}

export default function EquipmentImages(props: EquipmentImageProp) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <CustomImageList
      subjectId={props.equipment.id}
      subjectIdentifier={props.equipment.serialNumber}
      imageCols={isMobile ? 2 : 8}
      imageHeight={150}
      resourceType={ResourceType.Equipment}
    />
  );
}
